import { APP_INITIALIZER, Provider } from '@angular/core';

import { EnvironmentService } from '../environment/environment.service';
import { PlatformService, PlatformType } from '../platform/platform.service';

import { Logger } from './logger';

export function initializeLogger(envService: EnvironmentService, platformService: PlatformService) {
  return (): void => {
    const logLevel = envService.logLevel;
    const isProduction = envService.isProduction;
    const platformType = platformService.isServer ? PlatformType.SERVER : PlatformType.BROWSER;

    Logger.init({
      isProduction,
      platformType,
      logLevel
    });
  };
}

export const LOGGER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeLogger,
  deps: [EnvironmentService, PlatformService],
  multi: true
};
